import { useEffect, useRef } from "react";

export const useKeyboardVisibility = () => {
  const lastScrollPosition = useRef(0);

  useEffect(() => {
    const handleFocusIn = (e: FocusEvent) => {
      const target = e.target as HTMLElement;
      if (
        target.tagName === "INPUT" ||
        target.tagName === "TEXTAREA" ||
        target.getAttribute("contenteditable") === "true"
      ) {
        lastScrollPosition.current = window.scrollY;

        setTimeout(() => {
          target.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }, 300);
      }
    };

    const handleFocusOut = () => {
      setTimeout(() => {
        window.scrollTo({
          top: lastScrollPosition.current,
          behavior: "smooth",
        });
      }, 100);
    };

    document.addEventListener("focusin", handleFocusIn);
    document.addEventListener("focusout", handleFocusOut);

    return () => {
      document.removeEventListener("focusin", handleFocusIn);
      document.removeEventListener("focusout", handleFocusOut);
    };
  }, []);
};
